export default {"src":"/_next/static/media/google-play.f9c39480.svg","height":41,"width":136,"blurWidth":0,"blurHeight":0};